import { Rules, type RulesResponse, type ValidationResponse, type ValidationResult } from './helpers/types';

import { validateOneLowercase, validateOneUppercase } from './rules/case';
import { validateOneDigit } from './rules/digit';
import { validateMaxLength, validateMinLength } from './rules/length';
import { validateNoForbiddenChar } from './rules/noForbiddenChar';
import { validateOneSpecialChar } from './rules/specialChar';

export const validatePassword = (password: string): ValidationResponse => {
  const validateMinLengthResult = validateMinLength(password);
  const validateMaxLengthResult = validateMaxLength(password);
  const validateOneUppercaseResult = validateOneUppercase(password);
  const validateOneLowercaseResult = validateOneLowercase(password);
  const validateOneDigitResult = validateOneDigit(password);
  const validateOneSpecialCharResult = validateOneSpecialChar(password);
  const validateNoForbiddenCharResult = validateNoForbiddenChar(password);

  const validationResults: ValidationResult[] = [
    validateMinLengthResult,
    validateMaxLengthResult,
    validateOneUppercaseResult,
    validateOneLowercaseResult,
    validateOneDigitResult,
    validateOneSpecialCharResult,
    validateNoForbiddenCharResult,
  ];

  const isPasswordValid: boolean = validationResults.every((result) => result.valid);

  const rules: RulesResponse = {
    [Rules.minLength]: validateMinLength(password),
    [Rules.maxLength]: validateMaxLength(password),
    [Rules.uppercase]: validateOneUppercase(password),
    [Rules.lowercase]: validateOneLowercase(password),
    [Rules.digit]: validateOneDigit(password),
    [Rules.specialChar]: validateOneSpecialChar(password),
    [Rules.noForbiddenChar]: validateNoForbiddenChar(password),
  };

  const response: ValidationResponse = { isPasswordValid, rules };

  return response;
};
